module.exports = __webpack_public_path__ + "ab418df136a8240afe00f8cba7c70c5f.svg";